export const LOADER_STATUS = 'boilerplate/Gstr2a2bNew/DataUpload/LOADER_STATUS';
export const TABLE_DATA = 'boilerplate/Gstr2a2bNew/DataUpload/TABLE_DATA';
export const SAVE_TOTAL_PAGES = 'boilerplate/Gstr2a2bNew/DataUpload/SAVE_TOTAL_PAGES';
export const SET_ENTITY_LIST = 'boilerplate/Gstr2a2bNew/DataUpload/SET_ENTITY_LIST';
export const SET_SELECTED_ENTITY = 'boilerplate/Gstr2a2bNew/DataUpload/SET_SELECTED_ENTITY';
export const typeMap = {
    pass: "P",
    fail: "F",
    total: "T",
  };